import { objectsRHandler } from '@/utils/objectsRHandler';
import RatingEvent from '../list/rating-event/index';
import RatingEventDirection from '../list/rating-event/direction/index';

export const RatingEventManager = {
  get objects() {
    const path = 'event-ratings';
    return {
      ...objectsRHandler(path, RatingEvent),
    };
  },
  get list() {
    const path = 'event-ratings/list';
    return {
      ...objectsRHandler(path, RatingEventDirection),
    };
  },
};
